export const tokens = {
    size: 16,
    iconSize: 12,
};
